<template>
  <div class="menu">
    <div class="parent">{{titles[id].parentTitle}}</div>
    <ul v-if="titles[id].parent!=156 && titles[id].parent!=259">
      <li v-for="item in menus" :key="item.categoryId">
        <router-link :to="'/layout/news/'+item.categoryId">
        <div class="nowrap">{{item.categoryTitle}} ></div>
        </router-link>
      </li>
    </ul>
    <ul v-else>
      <li v-for="item in menus" :key="item.categoryId">
        <router-link :to="'/layout/contact/'+item.categoryId +'/'+$store.state.categoryAppid">
        <div class="nowrap">{{item.categoryTitle}} ></div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      menus: [],
      titles: {}
    }
  },
  props: [
    'id'
  ],
  created() {
    // console.log(this.$store.state.titles)
    this.titles = JSON.parse(localStorage.getItem('titles'))
    this.getMenus(this.id)
  },
  watch: {
    id(to, from) {
      this.getMenus(to)
    }
  },
  methods: {
    ...mapActions([
      'findSonTrees'
    ]),
    getMenus(id) {
      this.findSonTrees({
        basicCategoryid: this.titles[id].parent,
        categoryAppid: this.$store.state.categoryAppid
        }).then(res=>{
        // console.log(res)
        this.menus = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  margin: 10px 0 0 10px;
  color: #246DAB;
  .parent {
    color: #246DAB;
    border-bottom: solid 2px #ccc;
    font-size: 24px;
    padding: 0 20px;
  }
  ul {
    li {
      border-bottom: solid 1px #ccc;
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      a {
        color: #246DAB;
      }
    }
  }
}
.nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
  -webkit-line-clamp: 1; /* 控制最多显示几行 */
  -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
}
</style>
